<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>

<section class="form-creation-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="form-wrapper">
          <div class="form-wrapper__header">
            <h2 data-translation-key="reset_password_create_new_password">
              {{ 'reset_password.create_new_password' | translate }}
            </h2>
          </div>

          <p
            class="password-info"
            data-translation-key="reset_password_reset_password_note"
          >
            {{ 'reset_password.reset_password_note' | translate }}
          </p>
          <app-password-form
            [urlFront]="urlFront"
            [showTermsCheckbox]="true"
            (formChange)="onPasswordFormChange($event)"
            (formSubmit)="onSubmit($event)"
          ></app-password-form>
        </div>
      </div>
    </div>
  </div>
</section>
